<template>
    <div id="info" v-if="data" class="fade">
        <div class="row" style="">
            <div class="col-sm-12 big-title">
                <p class="h1 artwork-title text-center">SUPPORT US</p>
            </div>
        </div>
        <div class="row section-filetto " v-if="data && data.acf">
            <div class="col-sm-12">
                <div class="language">
                    <div class="col">
                        <p class="h4 text-justify" v-if="data.acf.main_text" v-html="data.acf.main_text"></p>
                    </div>
                    <div class="col">
                        <p class="h4 text-justify" v-if="data.acf.content_en" v-html="data.acf.content_en"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

export default {
    name: 'about',
    data() {
        return {
            data: null,
            contributions: null,
            pending: true,
            error: null,
            active: false
        }
    },
    components: {
    },
    computed: {

    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.pending = true
            try {
                const { data } = await axios.get(`${this.$store.state.api}/get_page`, {
                    params: { id: 'support-us' },
                })
                this.data = data;
                this.error = false;

                this.$store.commit('setPage', '/info')
                this.$store.commit('setIsPage', true)
            } catch (e) {
                this.data = null;
                this.error = e;
            }

            try {
                const { data } = await axios.get(`${this.$store.state.api}/get_contributions`, {
                    params: { id: 'about' },
                })
                this.contributions = data;
                this.error = false;
            } catch (e) {
                this.contributions = null;
                this.error = e;
            }

            this.pending = false;
        }
    },
}
</script>
<style type="text/css">
.contributions {
    margin-top: 20px;
}

.item-contributions {
    text-align: center;
}
</style>